import type React from 'react';

import { Field } from 'react-final-form';

import { NativeSelect } from '#src/app/shared/components/adminShadcn';
import { useFormValueSetter } from '#src/app/shared/form/mutators';

import type { AudienceBuilderAllowedFilter } from '../../../../../shared/types';
import { filterTypeValidator } from '../../../../../shared/validators';

export const FilterTypeField: React.FC<{
	fieldName: string;
	fieldValueName: string;
	allowedFilters: readonly AudienceBuilderAllowedFilter[];
}> = ({ fieldName, fieldValueName, allowedFilters }) => {
	const setFormValue = useFormValueSetter();

	return (
		<Field<string | undefined> name={fieldName} validate={filterTypeValidator}>
			{({ input, meta }) => (
				<div className="admin:flex-1 admin:[&_[data-slot=native-select-wrapper]]:w-full">
					<NativeSelect
						value={input.value ?? ''}
						name={input.name}
						onChange={(e) => {
							setFormValue(fieldValueName, '');
							input.onChange(e);
						}}
						aria-invalid={meta.touched && meta.error ? true : undefined}
					>
						<option value="">Add a filter</option>
						{allowedFilters.map((filter) => (
							<option key={filter.type} value={filter.type}>
								{filter.name}
							</option>
						))}
					</NativeSelect>
					{meta.touched && meta.error ? (
						<p role="alert" className="admin:mt-1 admin:text-xs admin:text-destructive">
							{meta.error as string}
						</p>
					) : null}
				</div>
			)}
		</Field>
	);
};
